import DomainOverview from './components/DomainOverview.vue';

export { DomainOverview };
